<template>
  <div>
   
    <b-table
      :tbody-tr-class="rowClass"
      ref="table"
      id="ctable"
      @row-dblclicked="dbClick"
      hover="hover"
      striped="striped"
      bordered="bordered"
      :small="small"
      :fields="fields"
      :fixed="fixed"
      responsive="sm"
      :items="this.tableData"
      class="text-center"
      :current-page="currentPage"
      custom-key="actions"
      :per-page="0"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :busy="isBusy"
      no-local-sorting
    >
      <template slot="HEAD_selected">
        <b-form-checkbox
          id="'checkbox-All'"
          v-model="allSelected"
          name="'checkbox-All'"
          @change="selectAll()"
        ></b-form-checkbox>
      </template>
      <template slot="selected" scope="item">
        <b-form-checkbox
          :id="'checkbox-' + item.index"
          v-model="item.item.selected"
          :name="'checkbox-' + item.index"
          @change="toggleSelectAll(item, item.item)"
        ></b-form-checkbox>
      </template>
      <template slot="table-busy">
     <b-spinner label="Spinning"></b-spinner>
      </template>
      <template slot="status" slot-scope="row">
        <b-form-checkbox
          name="check-button"
          switch
          :checked="row.item.status == 'active'"
          @change="updateItem(row.item)"
        ></b-form-checkbox>
      </template>
        <template slot="interViewNotificationStatus" slot-scope="row">
        <b-form-checkbox
          name="check-button"
          switch
          :checked="row.item.notify_status == 'active'"
         disabled
        ></b-form-checkbox>
      </template>
      <template slot="status_disable" slot-scope="row">
        <b-form-checkbox
          name="check-button"
          switch
          disabled
          :checked="row.item.status == 'active'"
        ></b-form-checkbox>
      </template>
      <template slot="actions" slot-scope="row">
        <button
          class="btn btn-primary btn-sm btn-size" 
          @click="editItem(row.item)"
        >
          <em class="fa fa-edit icon-size" ></em></button
        >&nbsp;
        <button
          class="btn btn-danger btn-sm btn-size" 
          @click="deleteItem(row.item)"
        >
          <em class="fa fa-trash icon-size"></em>
        </button>
      </template>
      <template slot="custom_actions" slot-scope="row">
        <button
          class="btn btn-primary btn-sm btn-size" 
          @click="editItem(row.item)"
        >
          <em class="fa fa-edit icon-size" ></em></button
        >&nbsp;
        
      </template>
      <template slot="actionDetail" slot-scope="row">
        <button
          class="btn btn-info btn-sm btn-size" 
          @click="dbClick(row.item)"
        >
          <em class="fa fa-address-book icon-size" ></em>
        </button>
      </template>
      <template slot="frequency_notify" slot-scope="row">
        {{
          row.item.notify_repeat_period != null
            ? row.item.notify_repeat_period +
              " " +
              getJapanese(row.item.notify_repeat_unit)
            : ""
        }}
        毎
      </template>
      <template slot="advance_notice" slot-scope="row">
        {{ row.item.notify_start != null ? row.item.notify_start : "" }} 日 前
      </template>
      <template slot="advance_notice_1" slot-scope="row">
        {{ row.item.notify_end != null ? row.item.notify_end : "" }} 日 まで
      </template>
      <template slot="icon" slot-scope="row">
        <div v-if="row.item.icon != null">
          <img :src="row.item.icon" width="30px" alt="" />
        </div>
      </template>
        <template slot="message" slot-scope="row">
        <p v-html="row.item.message" class="htmlPadding"></p>
      </template>

        <template slot="mig_notification.message" slot-scope="row">
        <p v-html="row.item.mig_notification.message" class="htmlPadding"></p>
      </template>
      <template slot="custom_address" slot-scope="row">
        <span v-if="row.item.address != null">
          {{
            row.item.address.prefecture != null && row.item.address.city != null
              ? row.item.address.prefecture + " " + row.item.address.city
              : ""
          }}
        </span>
      </template>
      <template slot="staff_detailName" slot-scope="row">
        <span v-if="row.item.staff_detail != null">
          {{
            row.item.staff_detail.last_name +
              " " +
              row.item.staff_detail.first_name
          }}</span
        >
      </template>
      <template slot="first_last_name" slot-scope="row">
        <span> {{ row.item.last_name + " " + row.item.first_name }}</span>
      </template>
      <template slot="personIncharge_contactaname" slot-scope="row">
        <span>
          {{
            row.item.partner_staff_detail.last_name +
              " " +
              row.item.partner_staff_detail.first_name
          }}</span
        >
      </template>
      <template slot="notify_date_time" slot-scope="row">
        <!-- 
          Call  TimeConversion to convert to local utc time.  
          Params: date and time, date format
         -->

{{row.item.notify_date ? row.item.notify_date : "" }}&nbsp; {{ row.item.notify_time ? getTimeFormet(row.item.notify_time)  : "" }}
        
      </template>
      <template slot="partnernotify_date_time" slot-scope="row">
        <span>
                <!-- 
          Call  TimeConversion to convert to local utc time.  
          Params: date and time, date format
         -->
         {{ row.item.mig_notification.notify_date ?  row.item.mig_notification.notify_date : "" }}&nbsp; {{ row.item.mig_notification.notify_time ? getTimeFormet(row.item.mig_notification.notify_time)  : "" }}
          
        </span>
      </template>
      <template slot="notification_actions" slot-scope="row">
        <button
          v-if="row.item.notify_status === 'scheduled'"
          class="btn btn-primary btn-sm btn-size" 
          @click="editItem(row.item)"
        >
          <em class="fa fa-edit icon-size" ></em>
        </button>
        <button
          v-else
          class="btn btn-primary btn-sm btn-size" 
          disabled
        >
          <em class="fa fa-edit icon-size" ></em></button
        >&nbsp;
        <button
          v-if="row.item.notify_status === 'scheduled'"
          class="btn btn-danger btn-sm btn-size" 
          @click="deleteItem(row.item)"
        >
          <em class="fa fa-trash icon-size" ></em>
        </button>
        <button
          v-else
          class="btn btn-danger btn-sm btn-size" 
          disabled
        >
          <em class="fa fa-trash icon-size" ></em>
        </button>
      </template>
      <template slot="notify_type" slot-scope="row">
        <span>
          {{
            row.item.notify_type === "all"
              ? "すべて"
              : row.item.notify_type === "partner"
              ? "提携先"
              : row.item.notify_type === "user"
              ? "ユーザー"
              : ""
          }}
        </span>
      </template>

      <template slot="notify_status" slot-scope="row">
        <span>
          {{
            row.item.notify_status === "scheduled"
              ? "配信待ち"
              : row.item.notify_status === "sent"
              ? "配信済み"
              : ""
          }}
        </span>
      </template>
      <template slot="mig_notification.notify_status" slot-scope="row">
        <span>
          {{
            row.item.mig_notification.notify_status === "scheduled"
              ? "配信待ち"
              : row.item.mig_notification.notify_status === "sent"
              ? "配信済み"
              : ""
          }}
        </span>
      </template>
      <template slot="mig_notification.notify_type" slot-scope="row">
        <span>
          {{
            row.item.mig_notification.notify_type === "all"
              ? "すべて"
              : row.item.mig_notification.notify_type === "partner"
              ? "提携先"
              : row.item.mig_notification.notify_type === "user"
              ? "ユーザー"
              : ""
          }}
        </span>
      </template>
      <template slot="notification_status" slot-scope="row">
        {{
          row.item.status === "read"
            ? "既読"
            : row.item.status === "unread"
            ? "未読"
            : ""
        }}
      </template>
    </b-table>
    
  </div>
</template>

<script>
import Vue from "vue";
import { type } from "os";
import { ContentLoader } from "vue-content-loader";
import _ from "lodash";
import moment from "moment";
import jstz from "jstimezonedetect";
import { TimeConversion } from "@/shared/utils.js";

export default {
  name: "c-table",
  inheritAttrs: false,
  props: {
    isBusy: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 10
    },
    dark: {
      type: Boolean,
      default: false
    },
    dbClick: {
      type: Function,
      default: () => []
    },
    selectItemsToDelete: {
      type: Function,
      default: () => []
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    total: {
      type: Number,
      default: 10
    },
    sortTable: {
      type: Function,
      default: () => {}
    },
    pagination: {
      type: Function,
      default: () => []
    },
    showEstimationList: {
      type: Function,
      default: () => []
    },
    update: {
      type: Function,
      default: () => []
    },
    edit: {
      type: Function,
      default: () => []
    },
    delete: {
      type: Function,
      default: () => []
    },
    user: {
      type: [Array, Object],
      default: () => []
    },
    countPerPage: {
      type: Number,
      default: 1
    }
  },
  data: () => {
    return {
      currentPage: 1,
      allSelected: false,
      pageOptions: [1, 10, 15],
      checkedItems: [],
      sortBy: "",
      sortDesc: false,
      TimeConversion: TimeConversion
    };
  },
  components: { ContentLoader, moment },

  computed: {
    items: function() {
      const items = this.tableData;
      
      return items;
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    },
    userData: function() {
      return this.userData;
    }
  },
  watch: {
    sortBy: function(newDate, oldData) {
      this.sortTable(this.sortBy, this.sortDesc ? "desc" : "asc");
    },
    sortDesc: function(newDate, oldData) {
      this.sortTable(this.sortBy, this.sortDesc ? "desc" : "asc");
    }
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.status === "unread") return "table-notification-unread";
    },
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    },
    getJapanese: function(name) {
      let list = _.find(
        [
          { id: "year", name: "年" },
          { id: "month", name: "月" },
          { id: "months", name: "月" },
          { id: "day", name: "日" }
        ],
        role => role.id == name
      );
      if (list) {
        return list.name;
      }
      return name;
    },
    selectAll() {
      if (!this.allSelected) {
        this.items.map(function(currentValue) {
          currentValue.selected = true;
        });
        this.selectItemsToDelete(this.items);
      } else {
        this.items.map(function(currentValue) {
          currentValue.selected = false;
        });
        this.selectItemsToDelete([]);
      }
    },
    toggleSelectAll(row, item) {
      this.checkedItems = this.items.filter(rowItem => rowItem.selected == true);
      setTimeout(() => {
        this.selectItemsToDelete(
          this.items.filter(itemToDelete => itemToDelete.selected == true)
        );
      }, 0);
    },
    paginateTable: function(pageNum) {
      this.pagination(pageNum);
    },
    updateItem: function(item) {
      this.update(item);
      this.$refs.table.refresh();
    },
    editItem: function(item) {
      this.edit(item);
    },
    deleteItem: function(item) {
      this.delete(item);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    perPageCount() {
      this.countPerPage(this.perPage);
    },
    /* Time formet to current system timezone */
    getTimeFormet(time) {
      return moment(time, "HH:mm:ss").format("HH:mm");
    }
  },
  created() {
    this.currentPage = this.countPerPage;
    this.items.map(function(currentValue) {
      currentValue.selected = false;
    });
  }
};
</script>
<style lang="scss">

#ctable thead {
  background: #595959;
  color: #fff;
  cursor: pointer;
  font-size: 13px;
}

#ctable thead th {
  border: 1px solid #dee2e6;
  min-width: 100px;
}
#ctable tbody tr td {
  cursor: pointer;
  font-size: 14px;
  padding: "8px !important";
  border: 1px solid #dee2e6;
}

.table th,
.table td {
  padding: 6px;
  vertical-align: top;
  border-top: 1px solid #e3e6f0;
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  // white-space: nowrap;
}
.htmlPadding p{
  margin-bottom: 0;
}
.htmlPadding ol{
  margin-bottom: 0;
}
.htmlPadding ul{
  margin-bottom: 0;
}
.icon-size{
  font-size: 13px;
}
.btn-size{
  font-size: 9px;
}
</style>
